module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner7.47eeede5.jpg";